export const roles = [
  { id: 'usuario', displayName: 'Usuario' },
  { id: 'repartidor', displayName: 'Repartidor' },
  { id: 'operativo', displayName: 'Operativo' },
  { id: 'administrativo', displayName: 'Administrativo' },
  { id: 'cliente-licenciatario', displayName: 'Cliente licenciatario' },
  { id: 'lite', displayName: 'Lite' },
  { id: 'basic', displayName: 'Basic' },
  { id: 'plus', displayName: 'Plus' },
  { id: 'superusuario', displayName: 'Superusuario' },
  { id: 'almighty', displayName: 'Almighty' },
  { id: 'cajero', displayName: 'Cajero' }
];

export const rolesName = {
  locker: 'locker'
};

// showSectionView --> depende de si en esa seccion hay vistas con allowed true entonces se ve la seccion caso contrario no se muestra la seccion
export const sectionViewsArr = [
  {
    id: 'PAQUETES',
    allowedAll: false,
    showSectionView: false,
    allowedViews: [
      { id: 'ENVIOS', label: 'Lista de envios', allowed: false, allowedPage: false },
      { id: 'EMPAQ_PRODUCTOS', label: 'Productos', allowed: false, allowedPage: false },
      { id: 'ENVIO_DETALLE', label: 'Detalle de envio', allowed: false, allowedPage: false },
      { id: 'EMPAQ_PRODUCTOS_DETAIL', label: 'Detalle del prod', allowed: false, allowedPage: false },
      { id: 'PICKUP', label: 'Pick up', allowed: false, allowedPage: false },
      { id: 'RECOLECCION', label: 'Recoleccion', allowed: false, allowedPage: false },
      { id: 'TRANSACCION', label: 'Transaccion', allowed: false, allowedPage: false }
    ]
  },
  {
    id: 'FUNCIONES',
    allowedAll: false,
    showSectionView: false,
    allowedViews: [
      { id: 'COTIZACION', label: 'Lista de tarifas', allowed: false, allowedPage: false },
      { id: 'ENVIO_NUEVO', label: 'Nuevo envio', allowed: false, allowedPage: false },
      { id: 'CART', label: 'Carrito de compras', allowed: false, allowedPage: false },
      { id: 'ADMINISTRACION', label: 'Administracion', allowed: false, allowedPage: false },
      { id: 'LOCKER', label: 'Loker', allowed: false, allowedPage: false },
      { id: 'WALLET', label: 'Wallet', allowed: false, allowedPage: false },
      { id: 'EMPAQUE', label: 'Empaque', allowed: false, allowedPage: false },
      { id: 'ADMINISTRACION_LOCKER', label: 'Administracion Lockers', allowed: false, allowedPage: false },
      { id: 'OPERACION_LOCKER_USER', label: 'Operacion user locker', allowed: false, allowedPage: false },
      { id: 'REG_REPARTIDOR_LOCKER', label: 'Registro envios del repartidor', allowed: false, allowedPage: false },
      { id: 'FUNCIONES_USER', label: 'Funciones usuarios', allowed: false, allowedPage: false }
    ]
  },
  {
    id: 'SERVICIOS',
    allowedAll: false,
    showSectionView: false,
    allowedViews: [
      { id: 'INICIO', label: 'Resumen recargas y servicios', allowed: false, allowedPage: false },
      { id: 'RECARGA', label: 'Recargas', allowed: false, allowedPage: false },
      { id: 'PAGO_SERVICIO', label: 'Pago de servicios', allowed: false, allowedPage: false },
      { id: 'SERVICIO-RECARGA', label: 'Recargas y Servicios', allowed: false, allowedPage: false }
    ]
  },
  {
    id: 'OLIMPO',
    allowedAll: false,
    showSectionView: false,
    allowedViews: [
      { id: 'OLIMPO', label: 'Vista del olimpo', allowed: false, allowedPage: false },
      { id: 'OLIMPO_REPORTS', label: 'Vista de reportes', allowed: false, allowedPage: false }
    ]
  },
  {
    id: 'LICENCIATARIOS',
    allowedAll: false,
    showSectionView: false,
    allowedViews: [
      { id: 'MIS_TICKETS', label: 'Tickets reportes de problemas', allowed: false, allowedPage: false },
      { id: 'CAJA', label: 'Caja del licenciatario', allowed: false, allowedPage: false },
      { id: 'USUARIO_ASIGNADO', label: 'Usuarios asignados al licenciatario', allowed: false, allowedPage: false }
    ]
  },
  {
    id: 'CRECE',
    allowedAll: false,
    showSectionView: false,
    allowedViews: [
      { id: 'CRECE_MAIN', label: 'Crece principal', allowed: false, allowedPage: false },
      { id: 'CRECE_SUCURSAL', label: 'Crece sucursal', allowed: false, allowedPage: false },
      { id: 'CRECE_REPARTOS', label: 'Crece repartos', allowed: false, allowedPage: false }
      // { id: 'CRECE_REPARTOS2', label: 'Crece repartos', allowed: false, allowedPage: false }
    ]
  }
];

export const usersType = [
  { id: 'ADMIN', label: 'Administrador' },
  { id: 'LICENCIATARIO', label: 'Licenciatario' },
  { id: 'ASSIGNED', label: 'Usuario asignado' }
];

export const initialPages = [
  { id: 'DASHBOARD', label: 'Dashboard inicio', url: '/dashboard' },
  { id: 'ENVIOS', label: 'Lista de envio', url: '/dashboard/paquetes/envios' },
  { id: 'ADMINISTRACION', label: 'Dashboard inicio', url: '/dashboard/cotizaciones/administracion' },
  { id: 'SERVICIOS_DASHBOARD', label: 'Dashboard de pagos y servicios', url: '/dashboard/servicios' }
];

const rolEjemplo = {
  id: 'cajero',
  displayName: 'Cajero',
  hasWallet: false,
  sectionViews: [
    {
      id: 'PAQUETES',
      allowedAll: false,
      showSectionView: false,
      allowedViews: [
        { id: 'ENVIOS', label: 'Lista de envios', allowed: false, allowedPage: false },
        { id: 'ENVIO_DETALLE', label: 'Detalle de envio', allowed: false, allowedPage: false },
        { id: 'PICKUP', label: 'Pick up', allowed: false, allowedPage: false },
        { id: 'RECOLECCION', label: 'Recoleccion', allowed: false, allowedPage: false },
        { id: 'TRANSACCION', label: 'Transaccion', allowed: false, allowedPage: false }
      ]
    },
    {
      id: 'FUNCIONES',
      allowedAll: false,
      showSectionView: false,
      allowedViews: [
        { id: 'COTIZACION', label: 'Lista de tarifas', allowed: false, allowedPage: false },
        { id: 'ENVIO_NUEVO', label: 'Nuevo envio', allowed: false, allowedPage: false },
        { id: 'CART', label: 'Carrito de compras', allowed: false, allowedPage: false },
        { id: 'ADMINISTRACION', label: 'Administracion', allowed: false, allowedPage: false },
        { id: 'LOCKER', label: 'Loker', allowed: false, allowedPage: false },
        { id: 'WALLET', label: 'Wallet', allowed: false, allowedPage: false }
      ]
    },
    {
      id: 'SERVICIOS',
      allowedAll: false,
      showSectionView: false,
      allowedViews: [
        { id: 'INICIO', label: 'Resumen recargas y servicios', allowed: false, allowedPage: false },
        { id: 'RECARGA', label: 'Recargas', allowed: false, allowedPage: false },
        { id: 'PAGO_SERVICIO', label: 'Pago de servicios', allowed: false, allowedPage: false }
      ]
    },
    {
      id: 'OLIMPO',
      allowedAll: false,
      showSectionView: false,
      allowedViews: [{ id: 'OLIMPO', label: 'Vista del olimpo', allowed: false, allowedPage: false }]
    },
    {
      id: 'LICENCIATARIOS',
      allowedAll: false,
      showSectionView: false,
      allowedViews: [
        { id: 'CAJA', label: 'Caja del licenciatario', allowed: false, allowedPage: false },
        { id: 'USUARIO_ASIGNADO', label: 'Usuarios asignados al licenciatario', allowed: false, allowedPage: false }
      ]
    }
  ]
};

// export const sectionViewsArr3 = [
//   {
//     id: 'PAQUETES',
//     allowedAll: false,
//     allowedViews: [
//       { id: 'ENVIOS', label: 'Lista de envios', allowed: true },
//       { id: 'ENVIO_DETALLE', label: 'Detalle de envio', allowed: true },
//       { id: 'PICKUP', label: 'Pick up', allowed: false },
//       { id: 'RECOLECCION', label: 'Recoleccion', allowed: false },
//       { id: 'TRANSACCION', label: 'Transaccion', allowed: false }
//     ]
//   },
//   {
//     id: 'FUNCIONES',
//     allowedAll: false,
//     allowedViews: [
//       { id: 'COTIZACION', label: 'Lista de tarifas', allowed: false },
//       { id: 'ENVIO_NUEVO', label: 'Nuevo envio', allowed: true },
//       { id: 'CART', label: 'Carrito de compras', allowed: true },
//       { id: 'ADMINISTRACION', label: 'Hugo', allowed: true },
//       { id: 'LOCKER', label: 'Loker', allowed: true },
//       { id: 'WALLET', label: 'Wallet', allowed: true }
//     ]
//   },
//   {
//     id: 'SERVICIOS',
//     allowedAll: false,
//     allowedViews: [
//       { id: 'INICIO', label: 'Resumen recargas y servicios', allowed: true },
//       { id: 'RECARGA', label: 'Recargas', allowed: true },
//       { id: 'PAGO_SERVICIO', label: 'Pago de servicios', allowed: true }
//     ]
//   }
// ];

// export const rolesPrueba = [
//   {
//     id: 'usuario',
//     displayName: 'Usuario',
//     sectionViews: sectionViewsArr3
//   }
// ];

// export const sectionViewsArr2 = [
//   {
//     id: 'PAQUETES',
//     allowedViews: [
//       { id: 'ENVIOS', label: 'Lista de envios' },
//       { id: 'ENVIO_DETALLE', label: 'Detalle de envio' },
//       { id: 'PICKUP', label: 'Pick up' },
//       { id: 'RECOLECCION', label: 'Recoleccion' },
//       { id: 'TRANSACCION', label: 'Transaccion' }
//     ]
//   },
//   {
//     id: 'FUNCIONES',
//     allowedViews: [
//       { id: 'COTIZACION', label: 'Lista de tarifas' },
//       { id: 'ENVIO_NUEVO', label: 'Nuevo envio' },
//       { id: 'CART', label: 'Carrito de compras' },
//       { id: 'ADMINISTRACION', label: 'Hugo' },
//       { id: 'LOCKER', label: 'Loker' },
//       { id: 'WALLET', label: 'Wallet' }
//     ]
//   },
//   {
//     id: 'SERVICIOS',
//     allowedViews: [
//       { id: 'INICIO', label: 'Resumen recargas y servicios' },
//       { id: 'RECARGA', label: 'Recargas' },
//       { id: 'PAGO_SERVICIO', label: 'Pago de servicios' }
//     ]
//   },
//   {
//     id: 'OLIMPO',
//     allowedViews: [{ id: 'OLIMPO', label: 'Vista del olimpo' }]
//   }
// ];

// export const roles2 = [
//   {
//     id: 'usuario',
//     displayName: 'Usuario',
//     sectionViews: [
//       {
//         id: 'OLIMPO',
//         allowedViews: [{ id: 'OLIMPO', label: 'Vista del olimpo' }]
//       },
//       {
//         id: 'FUNCIONES',
//         allowedViews: [
//           { id: 'COTIZACION', label: 'Lista de tarifas' },
//           { id: 'ENVIO_NUEVO', label: 'Nuevo envio' }
//         ]
//       }
//     ]
//   },
//   {
//     id: 'dios',
//     displayName: 'Dios',
//     sectionViews: [
//       {
//         id: 'OLIMPO',
//         allowedViews: [{ id: 'OLIMPO', label: 'Vista del olimpo' }]
//       },
//       {
//         id: 'FUNCIONES',
//         allowedViews: [
//           { id: 'CART', label: 'Carrito de compras' },
//           { id: 'COTIZACION', label: 'Lista de tarifas' },
//           { id: 'ENVIO_NUEVO', label: 'Nuevo envio' }
//         ]
//       }
//     ]
//   }
// ];
